import { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import DataTable from 'datatables.net-react';
import $ from 'jquery';
import Swal from 'sweetalert2';
import * as BullCache from "../../util/BullCache";
import { PositionServices } from '../../services/PositionServices';
import "../custom.css";

function PositionStatus() {
  const [loading, setLoading] = useState(false);
  const [positionData, setPositionData] = useState([]);

  var user = BullCache.getFromCache("user");

  useEffect(() => {
    fetchPositionStatus();
  }, []);

  const fetchPositionStatus = () => {
    setLoading(true);
    const dataToSubmit = {
      adminId: user.adminId,
      loginId: user.adminId,
    };

    PositionServices.getPositionOnlyStatus(dataToSubmit).then((resp) => {
      setLoading(false);
      if (resp.code === 1 && resp.data && resp.data.positionList) {
        const mapped = [];
        resp.data.positionList.forEach((item) => {
          const clientName = item.user
            ? `${item.user.firstName} (${item.user.userName}) / ${item.user.admin || ''}`
            : '';
          const userId = item.user ? item.user.userid : '';

          if (item.position && item.position.length > 0) {
            item.position.forEach((p) => {
              const scriptNameParts = (p.scriptName || '').split('#');
              const segment = scriptNameParts[0] || '';
              const symbol = scriptNameParts[1] || '';
              const expiry = scriptNameParts[2] || '';

              mapped.push({
                client: clientName,
                userId: userId,
                scriptId: p.scriptId || '',
                segment: segment,
                script: symbol,
                expiry: expiry,
                type: p.type || '',
                qty: p.qty || 0,
                lot: p.lot || 0,
                buyQty: p.totalBuyQty || 0,
                sellQty: p.totalSellQty || 0,
                buyLot: p.totalBuyLot || 0,
                sellLot: p.totalSellLot || 0,
                action: '',
              });
            });
          }
        });
        setPositionData(mapped);
      } else {
        setPositionData([]);
      }
    }).catch(() => {
      setLoading(false);
      setPositionData([]);
    });
  };

  const handleProcessed = (rowData) => {
    if (!rowData?.userId || !rowData?.scriptId) {
      Swal.fire({ icon: 'error', text: 'Invalid data!' });
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to mark this position as PROCESSED?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      cancelButtonColor: "#d33",
    }).then((result) => {
      if (result.isConfirmed) {
        PositionServices.updatePositionStatusToProcessed({
          userId: rowData.userId,
          keyword: rowData.scriptId,
        }).then((res) => {
          if (res.code === 1) {
            Swal.fire({ icon: 'success', text: res.messages || 'Updated to PROCESSED', timer: 2000 });
            fetchPositionStatus();
          } else {
            Swal.fire({ icon: 'error', text: res.messages || 'Failed to update' });
          }
        }).catch((error) => {
          Swal.fire({ icon: 'error', text: error?.response?.data?.messages || 'Network error' });
        });
      }
    });
  };

  return (
    <div>
      {loading ? (
        <div className="container vh-100">
          <div className="d-flex align-items-center justify-content-center h-90">
            <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
      <Card className="mt-2 mb-5">
        <Card.Body>
          <div className="table-responsive">
            <DataTable
              id="positionStatusTable"
              className="mt-1 table table-striped text-center bg-secondary-row fss-08 table-responsive"
              options={{
                pageLength: 50,
                order: [],
                language: {
                  emptyTable: 'No Data Found',
                  lengthMenu: 'entries per page _MENU_',
                },
                drawCallback: function () {
                  $('.btn-processed-status').off('click').on('click', function () {
                    const encodedData = $(this).attr('data-full');
                    if (encodedData) {
                      try {
                        const parsedData = JSON.parse(decodeURIComponent(encodedData));
                        handleProcessed(parsedData);
                      } catch (err) {
                        console.error('Failed to parse data-full', err);
                      }
                    }
                  });
                }
              }}
              columns={[
                { title: 'CLIENT', data: 'client' },
                { title: 'SEGMENT', data: 'segment' },
                { title: 'SCRIPT', data: 'script' },
                { title: 'EXPIRY', data: 'expiry' },
                { title: 'TYPE', data: 'type' },
                { title: 'QTY', data: 'qty' },
                { title: 'LOT', data: 'lot' },
                { title: 'BUY QTY', data: 'buyQty' },
                { title: 'SELL QTY', data: 'sellQty' },
                { title: 'BUY LOT', data: 'buyLot' },
                { title: 'SELL LOT', data: 'sellLot' },
                { title: 'ACTION', data: 'action', render: (data, type, full) => {
                  const safeData = encodeURIComponent(JSON.stringify(full));
                  return `<button class="btn btn-warning btn-sm fss-07 btn-processed-status" data-full='${safeData}'>PROCESSED</button>`;
                }},
              ]}
              data={positionData}
            />
          </div>
        </Card.Body>
      </Card>
      )}
    </div>
  );
}

export default PositionStatus;
